import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@hooks';
import { canAccessOwnerArea } from '@utils';

/**
 * Route guard for owner-only areas (Settings, Users — F1.3/F1.7/F9.1). Renders
 * nested inside ProtectedRoute, so `user` is already resolved here; a staff user
 * is redirected to the 403 page. The nav also hides these links for staff, but
 * this is the authoritative block (deep links / typed URLs).
 */
export function OwnerRoute() {
  const { user } = useAuth();
  if (!canAccessOwnerArea(user)) {
    return <Navigate to="/403" replace />;
  }
  return <Outlet />;
}

export default OwnerRoute;
